var React = require('react');

function SingleCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.88,18.42l1.49-1.49a1.74,1.74,0,0,0,0-2.48L12,1A1.76,1.76,0,0,0,9.47,1L8.23,2.26A2.11,2.11,0,0,0,8,5L1,12a1.77,1.77,0,0,0,0,2.49L12,25.37a1.76,1.76,0,0,0,2.49,0l7-6.95A1.76,1.76,0,0,0,23.88,18.42Z"}));
}

SingleCard.defaultProps = {"id":"SingleCardIcon","data-name":"SingleCardIcon","viewBox":"0 0 26.38 26.38"};

module.exports = SingleCard;

SingleCard.default = SingleCard;
